<template>
  <div>
    <header-component position-relation></header-component>
    <div class="visual-container">
      <div class="body-max-container-800">
        <h5 class="tag"># {{ resourceData.resourceType | filterTag }}</h5>
        <h1 class="title">{{ resourceData.title }}</h1>
        <div class="preview-download-box">
          <img v-if="resourceData.resourcePreview && resourceData.resourcePreview !== ''" class="preview-img" :src="getResourceUrl(resourceData.resourcePreview)" alt>
          <div v-if="resourceData.haveResourceFile" class="download-btn enter-btn" @click="handleDownloadResource">
            <img src="../../assets/img/icon_download.svg" alt>
            <span>立刻下載</span>
          </div>
        </div>
        <ul>
          <li v-if="showContent('resourceDesc')">
            <div class="home-content-info">
              <div class="home-content-info-body">
                <div class="title">簡介</div>
                <div class="subTitle">
                  {{ resourceData.resourceDesc }}
                </div>
              </div>
            </div>
          </li>
          <li v-if="resourceData.resourceType === 2">
            <div class="home-content-info">
              <div class="home-content-info-body">
                <div class="title">詳細介紹</div>
                <el-form label-position="left" label-width="100px" :model="memberModel">
                  <el-form-item v-if="showContent('themeName')" label="主題名稱">
                    <span class="sub-title">{{ resourceData.themeName }}</span>
                  </el-form-item>
                  <el-form-item v-if="showContent('author')" label="教案設計者">
                    <span class="sub-title">{{ resourceData.author }}</span>
                  </el-form-item>
                  <el-form-item v-if="showContent('lessonHours')" label="授課時數">
                    <span class="sub-title">{{ resourceData.lessonHours }}</span>
                  </el-form-item>
                  <el-form-item v-if="showContent('uintTag')" label="融入領域單元或主題教學">
                    <span class="sub-title">{{ resourceData.uintTag }}</span>
                  </el-form-item>
                  <el-form-item v-if="showContent('issueTag')" label="重要議題">
                    <span class="sub-title">{{ resourceData.issueTag }}</span>
                  </el-form-item>
                  <el-form-item v-if="showContent('studentTag')" label="教學對象">
                    <span class="sub-title">{{ resourceData.studentTag }}</span>
                  </el-form-item>
                  <el-form-item v-if="showContent('organization')" label="機構名稱">
                    <span class="sub-title">{{ resourceData.organization }}</span>
                  </el-form-item>
                  <el-form-item v-if="showContent('lessonUrl')" label="課程連結">
                    <span class="sub-title link-span" style="word-wrap: break-word;" @click="handleGoLessonUrl">{{ resourceData.lessonUrl }}</span>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../../components/HeaderComponent";
import FooterComponent from "../../components/FooterComponent";
import IndexMixin from "@/mixins/index-mixin";
import { DeviceTypeEnum } from "@/utils/enum";
import { resourceGroupOptionsKeyValue } from "@/utils/options";
export default {
  name: "Visual",
  mixins: [IndexMixin],
  components: { FooterComponent, HeaderComponent },
  data() {
    return {
    };
  },
  filters: {
    filterTag: function(val) {
      return resourceGroupOptionsKeyValue[val]
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player//自定义播放
    },
    /**
     * @returns {ResourceModel}
     */
    resourceData() {
      return this.$store.getters.resources.filter(x => x.resourceId === parseInt(this.$route.params.id))[0]
    },
    isMobile() {
      return this.$store.getters.device === DeviceTypeEnum.MOBILE
    }
  },
  watch: {
  },
  methods: {
    showContent(key) {
      return (this.resourceData && this.resourceData[key] && this.resourceData[key] !== '')
    },
    handleDownloadResource() {
      if (this.resourceData.downloadByMember === false || this.resourceData.downloadByMember && this.$store.getters.token) {
        this.goDownloadResource(this.resourceData.resourceFile)
      } else {
        this.$12nightsConfirm({
          title: "提示",
          message: "請先登入或註冊會員後，即可下載！"
        }).then(() => {
          this.$router.push({
            name: "Login"
          })
        })
      }
    },
    handleGoLessonUrl() {
      this.$12nightsConfirm({
        title: "您將前往前往外部連結",
        message: this.resourceData.lessonUrl
      }).then(() => {
        window.open(this.resourceData.lessonUrl, '_blank')
      })
    }
  },
};
</script>

<style lang="scss">
.el-form-item {
  margin-bottom: 5px !important;
}
.el-form-item__label {
  color: black;
  font-size: 0.8em;
}
.el-form-item__content {
  color: black;
  font-size: 0.8em;
}
</style>

<style lang="scss" scoped>
.link-span {
  display: unset !important;
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}
</style>
